module.exports = __webpack_public_path__ + "static/media/about.5e2e4632.gif";